import classNames from "classnames";
import React, { FC } from "react";
import { Link } from "../../types/link";
import { isNullOrWhiteSpace } from "../utilities/string";

export type BreadcrumbProps = Pick<Link, "label" | "title"> & {
  isLast?: boolean;
  url?: string;
};

export const Breadcrumb: FC<BreadcrumbProps> = ({ label, isLast, title, url }) => {
  if (isNullOrWhiteSpace(url)) {
    return <span className="flex text-xsmall font-300 text-secondary-400">{label}</span>;
  } else {
    return (
      <a
        href={url}
        className={classNames(
          "flex text-xsmall font-600 text-secondary-400 hover:underline",
          !isLast
            ? "relative after:absolute after:border-r after:rotate-12 after:top-1/2 after:-translate-y-1/2 after:-right-xs after:-translate-x-xxxs after:h-xs after:text-theme3-500"
            : null
        )}
        title={title}
      >
        {label}
      </a>
    );
  }
};
